import { Action } from 'redux';

export const SHOW_BUYER_ACCESS_RULES_EXPORT_MODAL = 'buyer-access-rules/SHOW_BUYER_ACCESS_RULES_EXPORT_MODAL';
export const HIDE_BUYER_ACCESS_RULES_EXPORT_MODAL = 'buyer-access-rules/HIDE_BUYER_ACCESS_RULES_EXPORT_MODAL';
export const EXPORT_BUYER_RULES = 'buyer-access-rules/EXPORT_BUYER_RULES';

export const showBuyerAccessRulesExportModal = () => {
  return {
    type: SHOW_BUYER_ACCESS_RULES_EXPORT_MODAL,
  };
};
export const hideBuyerAccessRulesExportModal = () => {
  return {
    type: HIDE_BUYER_ACCESS_RULES_EXPORT_MODAL,
  };
};
export const exportBuyerRules = (data: any) => {
  return {
    type: EXPORT_BUYER_RULES,
    payload: data,
  };
};

export interface ShowBuyerAccessRulesExportModalAction extends Action<typeof SHOW_BUYER_ACCESS_RULES_EXPORT_MODAL> {}
export interface HideBuyerAccessRulesExportModalAction extends Action<typeof HIDE_BUYER_ACCESS_RULES_EXPORT_MODAL> {}

export type BuyerAccessRulesAction = ShowBuyerAccessRulesExportModalAction | HideBuyerAccessRulesExportModalAction;
